import React, { useEffect, useState } from 'react';
import useStyles from "../style";
import {renderErrorCreatePool} from "../../../utils/validate";

function CustomNetworkLink(props: any) {
  const classes = useStyles();
  const {
    register, errors,
    poolDetail, watch, setValue, getTokenInforDetail
  } = props;
  const renderError = renderErrorCreatePool;

  useEffect(() => {
      register("external_refund_link");
    }, [register]);

  return (
    <>
      <div className={classes.formControl}>
        <label className={classes.formControlLabel}>Custom Network Link</label>
        <input
          type="text"
          name='external_refund_link'
          defaultValue={poolDetail?.external_refund_link}
          ref={register({ required: true })}
          className={classes.formControlInput}
        />

        <p className={classes.formErrorMessage}>
          {
            renderError(errors, 'external_refund_link')
          }
        </p>
      </div>
    </>
  );
}

export default CustomNetworkLink;
